import {gql} from "@apollo/client/core";

export const LocaleFragment = gql`
    fragment LocaleFragment on LocaleViewTemplate {
        usanaLocale
        continentTag
        countryDisplayTag
        languageDisplayTag
        country
        language
    }
`;
